<template>
  <div name="cardloopimage" @click="onClick">
    <div
      class="grid-content"
      style="position:relative;height:80px;overflow:hidden;border-radius:13px;"
    >
      <!-- <img :src="folder+img" style="align:center;max-width:80px;border-top-right-radius:20px;border-bottom-left-radius:20px;" /> -->
      <el-image
        :src="folder + img"
        style="align:center;max-width:80px;border-top-right-radius:20px;border-bottom-left-radius:20px;"
        lazy
      ></el-image>
      <!-- @mouseover="onover" @mouseout="onout" -->
    </div>
    <h4 style="color:#ffffff">
      {{ name }}<br />
      <img
        v-for="(unit,index5) in platfoms"
        :key="index5"
        :src="unit"
        style="width:16px;height:16px;margin-right:2px;"
      /> 
    </h4>
  </div>
</template>

<script>
export default {
  name: "CardLoopImage",
  props: {
    platfom: Array,
    name: String,
    folder: String,
    img: String,
    type:String,
    // video:String,
  },
  data() {
    return {
      // img:"./img/def.png",
      platfoms: []
      // nowImgId:0,
    };
  },
  mounted: function() {
    // this.img = this.folder+this.imgs[0];
    // setInterval(() => {

    // }, interval);
    if (this.platfom != null && this.platfom.length > 0) {
      for (var i = 0; i < this.platfom.length; i++) {
        switch (this.platfom[i]) {
          case "ios":
          case "android":
          case "windows":
          case "mac":
          case "linux":
          case "other":
          case "web":
          case "wechat":
          case "wegame":
          case "weapp":
          case "unity":
          case "btc":
          case "godot":
          case "game_puzzle":
          case "manage":
          case "server":
          case "nodejs":
          case "vscode":
          case "greasymonkey":
          case "garmin":
          case "pebble":
            this.platfoms.push("./img/platfom/" + this.platfom[i] + ".png");
        }
      }
    }
    // this.platfoms = ["./img/platfom/ios.png","./img/platfom/android.png"];
    // console.log(this.platfom);
  },
  methods: {
    onClick(){
      // this.$router.push("/info", props:{folder:this.folder, name:this.name});
      this.$router.push(["/info",this.type,this.name].join("/"));
    },
    // onover(){
    //   this.img = this.folder+this.imgs[1];
    // },
    // onout(){
    //   this.img = this.folder+this.imgs[0];
    // },
  }
};
</script>

<style></style>
